import { getEnvironment } from 'src/lib/featureFlags';

import { processSilentOAuth as processCuritySilentOAuth } from './curitySilentOAuth';
import { processSilentOAuth as processLegacySilentOAuth } from './legacySilentOAuth';

export const processSilentOAuth = getEnvironment().curityLogin ? processCuritySilentOAuth : processLegacySilentOAuth;
